import Swal from 'sweetalert2'
import CryptoJS from 'crypto-js';
import config from "../config/config.json";

export const headersWithAuthWithoutBody = (method, auth) => ({
  method: method,
  headers: auth,
});

export const headersWithoutAuthWithoutBody = (method) => ({
  method: method,
});

function encryptPayload(data) {
  if (config.ENV === 'development') {
    return data;
  }
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), config.SECRETKEY).toString();
  return { encrypted: ciphertext };
}

export const headersWithAuth = (method, userData, auth) => ({
  method: method,
  headers: auth,
  body: JSON.stringify(encryptPayload(userData)),
});

export const headersWithoutAuth = (method, userData) => ({
  method: method,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(encryptPayload(userData)),
});

export const handleResponse = (response) => {
  try {
    if (!response) return;
    if (
      response.statusCode === 401 &&
      (response.customMessage === "Token expired. Please login again" ||
        response.customMessage === "Invalid token" ||
        response.forceLogout)
    ) {
      localStorage.removeItem("token");
      sessionStorage.clear();
      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "error",
        title: "Session expired. Please login again.",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      setTimeout(() => {
        window.location.href = "/login";
      }, 2600);
      return;
    }
    if (response.statusCode === 200) {
      return Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: response.customMessage || "Success",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
    return Swal.fire({
      toast: true,
      position: "bottom-end",
      icon: "error",
      text: response.customMessage || "Something went wrong",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  } catch (err) {
    console.error("handleResponse error:", err);
    Swal.fire({
      toast: true,
      position: "bottom-end",
      icon: "error",
      title: "Unexpected error occurred",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  }
};

const apiControllers = {};
export function cancelPreviousRequest(apiName) {
  if (apiControllers[apiName]) {
    apiControllers[apiName].abort();
  }
  const controller = new AbortController();
  apiControllers[apiName] = controller;
  return controller.signal;
}

export function decryptResponse(result) {
  if (config.ENV === 'development') {
    return result;
  }
  let encrypted = result.encrypted
  const bytes = CryptoJS.AES.decrypt(encrypted, config.SECRETKEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
}